const pushEventDataLayer = (category, action, label, value = '') => {

  // trackEvent
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'ga_event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  })


  if (process.env.ENVIRONMENT === 'DEV') {
    console.log('===PUSH  DATALAYER')
    console.log('category: ', category)
    console.log('label: ', label)
    console.log('action: ', action)
    console.log('===PUSH  DATALAYER')
  }


}
export default pushEventDataLayer
